import React, { PropTypes } from 'react';

import ReviewUser from './User';
import ReviewContent from './ReviewContent';

import './styles.scss';


const BaseReview = props => (
  <li styleName='review'>

    <ReviewUser user={props.user} />

    <ReviewContent {...props} />

  </li>
);

BaseReview.propTypes = {
  user: PropTypes.shape({ pk: PropTypes.number }).isRequired,
};

export default BaseReview;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/BaseReview/Review/index.jsx